import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import notify from './plugins/notify'
import './assets/css/global.css'
import ElementUI from 'element-ui';
// 注册全局指令
import Directives from './directives'
Vue.use(Directives)
import 'element-ui/lib/theme-chalk/index.css';
// ✅ 只屏蔽 Agora-SDK 的 console 输出（不影响你的业务日志）
(function muteAgoraConsole() {
  const match = (args) => {
    const s = String(args?.[0] ?? "");
    // 你截图里是 "Agora-SDK" / "AgoraRTC_N-production"
    return s.includes("Agora-SDK") || s.includes("AgoraRTC");
  };

  ["log", "info", "debug", "warn"].forEach((k) => {
    const raw = console[k];
    console[k] = (...args) => {
      if (match(args)) return;
      raw.apply(console, args);
    };
  });
})();
// import AgoraRTC from "agora-rtc-sdk-ng";

// // 兼容不同版本的 log level 枚举
// const NONE =
//   AgoraRTC.LOG_LEVEL_NONE ??
//   AgoraRTC.LogLevel?.NONE ??
//   AgoraRTC.Logger?.NONE ??
//   0; // 兜底：很多实现里 0 表示 NONE

// if (AgoraRTC.setLogLevel) {
//   AgoraRTC.setLogLevel(NONE);
// }

// console.warn("[BOOT] agora log level set", NONE, "Logger?", !!AgoraRTC.Logger);
Vue.config.productionTip = false

Vue.use(ElementUI);
Vue.use(notify)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')